import { useState } from 'react';

export function useCreateDocumentFlow() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDocType, setSelectedDocType] = useState(null);

  function openDialog() {
    setIsOpen(true);
    setSelectedDocType(null);
  }

  function closeDialog() {
    setIsOpen(false);
    setSelectedDocType(null);
  }

  return {
    isOpen,
    selectedDocType,
    setSelectedDocType,
    openDialog,
    closeDialog,
  };
}
